import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/8556163b-a21a-4889-85bf-57bee7a466d6/images/7ba5656d74592b754e26a832facbac5285c7759b3eccc54a3e421d20c71636dc.png";

export default function Hero() {
  const navigate = useNavigate();
  const goTo = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-[100vh] flex items-end overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Fiber optics"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 hero-overlay" />
        <div className="absolute inset-0 grid-bg opacity-50" />
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 pt-32">
        <div className="grid grid-cols-12 gap-8 items-end">
          <div className="col-span-12 lg:col-span-8 fade-up">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-[#E63946]" />
              <span className="overline">Fiber Optic · Specialists</span>
            </div>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl xl:text-7xl tracking-tighter font-medium text-white leading-[1.02]">
              Προηγμένες
              <br />
              <span className="text-[#E63946]">υποδομές</span> οπτικών ινών.
            </h1>
            <p className="mt-8 text-base sm:text-lg max-w-xl text-[#A1A1AA] leading-relaxed">
              Κατασκευή και άμεση αποκατάσταση βλαβών οπτικών ινών με κορυφαία
              ακρίβεια. Συνεργάτες των μεγαλύτερων παρόχων τηλεπικοινωνιών στην
              Ελλάδα.
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <button
                onClick={() => goTo("/contact")}
                data-testid="hero-cta-quote-btn"
                className="btn-primary px-7 py-4 text-sm font-medium inline-flex items-center gap-2"
              >
                Ζητήστε Προσφορά
                <ArrowRight size={16} />
              </button>
              <button
                onClick={() => goTo("/services")}
                data-testid="hero-cta-services-btn"
                className="btn-outline px-7 py-4 text-sm font-medium"
              >
                Δείτε Υπηρεσίες
              </button>
            </div>
          </div>

          <div className="hidden lg:block col-span-4">
            <div className="border border-[#27272A] bg-[#0F0F11]/70 backdrop-blur-md p-6">
              <div className="overline mb-4">Δείκτες · Operations</div>
              <div className="space-y-5">
                <Stat label="Έτη εμπειρίας" value="15+" />
                <div className="section-divider" />
                <Stat label="Έργα οπτικών ινών" value="500+" />
                <div className="section-divider" />
                <Stat label="Χρόνος ανταπόκρισης" value="< 24h" />
                <div className="section-divider" />
                <Stat label="Έδρα" value="Άγιοι Ανάργυροι" small />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom ticker */}
      <div className="absolute bottom-0 inset-x-0 border-t border-white/5 bg-[#050505]/60 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-end text-xs">
          <div className="font-mono-th text-[#A1A1AA]">
            Νικολάου Πλαστήρα 17 / Άγιοι Ανάργυροι
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ label, value, small }) {
  return (
    <div className="flex items-baseline justify-between gap-4">
      <span className="text-xs uppercase tracking-wider text-[#A1A1AA] font-mono-th">
        {label}
      </span>
      <span
        className={`font-heading text-white ${small ? "text-base" : "text-2xl"} font-medium`}
      >
        {value}
      </span>
    </div>
  );
}
